<template>
	<div @click.stop>
		<span class="agreement-message" @click="popupVisible = true">
			《用户授权协议》
		</span>
		<van-popup
			v-model="popupVisible"
			position="bottom"
			round
			:get-container="getContainer"
		>
			<div class="popup-content" :style="{marginBottom:(bottomBarHeight)+'px'}">
				<div class="popup-tit">
					用户协议与隐私说明
					 <img
						src="@/assets/annualReport/close_black.svg"
						class="u-icon-close"
						@click="popupVisible = false"
					/>
				</div>
				<div class="popup-text">
					<div
						v-for="(item, index) in descInfo"
					 :key="index"
					>
						<div class="popup-subtit">{{ item.title || ''}}</div>
						<div class="popup-message">{{ item.message }}</div>
					</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>
<script>
	export default {
		name: "Agreement",
		props: {
			bottomBarHeight: {
			type: Number,
			default: 0,
			},
		},
		data() {
			return {
				popupVisible: false,
				descInfo: [
					{
						title: null,
						message:'欢迎体验“2025库迪主理人报告”（以下简称“报告”或“主理人报告”）！本次活动由库迪科技（天津）有限公司及其关联公司（包括但不限于库迪咖啡（天津）有限公司、库迪供应链（安徽）有限公司、以下简称“我们”）提供。为保障您的个人信息权益，特制定本《“2025库迪主理人报告”用户协议与隐私说明》（以下简称“本说明”），向您说明我们收集、使用您个人信息的目的及方式。'
					},
					{
						title: "1. 信息使用",
						message: '您点击“进门领取报告”按钮后，为向您提供个性化的主理人报告，我们将使用您的库迪咖啡小程序/APP账号信息（如昵称、手机号），以及您在2025自然年度内通过库迪咖啡小程序/APP平台产生的消费与行为数据，包括但不限于：订单记录、消费时间、消费门店、消费偏好等。'
					},
					{
						title: "2. 信息展示",
						message: '您的报告将展示您的库迪咖啡小程序/APP昵称、消费偏好、常去门店等统计信息。如您选择公开分享，他人可通过您分享的链接或截图查看相关内容。请注意，分享后信息可能被他人保存或转发，请您谨慎选择公开内容。'
					},
					{
						title: "3. 画面展示",
						message: '本报告的视觉设计风格与装饰性画面由人工智能（AI）工具辅助生成，相关内容仅为艺术化创作，仅供参考与娱乐。'
					},
					{
						title: "4. 数据说明",
						message: '报告系基于您在库迪咖啡小程序/APP的实际消费与行为数据，通过统计与算法生成，可能与您的实际记忆或理解存在细微差异，仅供参考与娱乐用途。'
					},
					{
						title: "5. 其他约定",
						message: '本说明未尽事宜，适用《库迪咖啡用户使用协议》和《库迪咖啡用户隐私协议》的相关规定。'
					},
					{
						title: "6. 联系我们",
						message: '如您对本活动或本说明有任何疑问、意见或建议，可通过库迪咖啡官方客服渠道联系我们。'
					},
					{
						title: "7. 特别提示",
						message: '- 数据统计周期为2025年1月1日至2025年12月20日。\n- 数据来源包括：库迪咖啡小程序/APP。'
					},
					{
						title: null,
						message: '库迪咖啡\n2025年12月20日'
					}
				],
			};
		},
		methods: {
			getContainer() {
				return document.body;
			},
		},
	};
</script>
<style lang="scss" scoped>
	.rule-icon {
	}
	.van-popup--bottom {
		border-radius: 16px 16px 0 0;

		.popup-content {
			width: 100%;
			height: 100%;

			.popup-tit {
				position: relative;
				text-align: center;
				line-height: 96px;
				height: 96px;
				color: #3a3b3c;
				font-size: 32px;
				font-weight: bold;
			}

			.u-icon-close {
				position: absolute;
				right: 20px;
				top: 25px;
				width: 48px;
      			height: 48px;
			}

			.popup-text {
				//width: calc(100% - 96px);
				padding: 0 32px 68px;
				line-height: 40px;
				margin: auto;
				max-height: 70vh;
				overflow: auto;
				text-align: left;
				.popup-subtit{
					font-weight: 600;
					font-size: 26px;
					line-height: 40px;
					margin-top: 16px;

				}
				.popup-message {
					// margin-top: 16px;
					font-size: 26px;
					white-space: pre-wrap;
					color: #3a3b3c;
				}
			}

			.popup-btn {
				width: calc(100% - 64px);
				margin: 0 auto;
				margin-top: 16px;
				margin-bottom: 48px;
				line-height: 96px;
				background: linear-gradient(153deg, #ff7673 0%, #ff3d3d 100%);
				border-radius: 8px;
				color: #ffffff;
				font-weight: bold;
				font-size: 32px;
				text-align: center;
				border-radius: 48px;
			}
		}
	}
</style>
